/**
 * Connection state as the UI needs it.
 *
 * Five outcomes, kept distinct on purpose. Collapsing them into
 * connected/not-connected would tell a user with an expired token that they
 * have no connection, and send them to create a duplicate.
 */
export const CONNECTION_UI_STATE = {
  connected: 'connected',
  authorizing: 'authorizing',
  reauthRequired: 'reauth_required',
  failed: 'failed',
  notConnected: 'not_connected',
}

const BY_PROVIDER_STATUS = {
  ACTIVE: CONNECTION_UI_STATE.connected,
  INITIATED: CONNECTION_UI_STATE.authorizing,
  INITIALIZING: CONNECTION_UI_STATE.authorizing,
  EXPIRED: CONNECTION_UI_STATE.reauthRequired,
  FAILED: CONNECTION_UI_STATE.failed,
  INACTIVE: CONNECTION_UI_STATE.notConnected,
}

export function connectionUiState(connection) {
  if (!connection) return CONNECTION_UI_STATE.notConnected
  // A disabled connection still exists but cannot be used, so it reads as
  // needing attention rather than as working.
  if (connection.is_disabled) return CONNECTION_UI_STATE.reauthRequired
  return BY_PROVIDER_STATUS[connection.status] ?? CONNECTION_UI_STATE.notConnected
}

export function isTerminalStatus(status) {
  return status === 'ACTIVE' || status === 'FAILED' || status === 'EXPIRED'
}
